/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { ExportSheet } from "react-xlsx-sheet";
import XLSX from "xlsx";

class TicketType extends Component {
  state = {
    data: {
      EnName: "",
      ArName: "",
      KuName: "",
      NeedEmployee: false,
      ChargeDescription: "",
      slaMinutes: ""
    },

    contentHeader: "Ticket Types",
    addButtonLabel: "Add Ticket Type",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetTicketTypes",
    singleItemUrl: "/api/data/GetTicketType",
    addUrl: "/api/data/AddTicketType",
    editUrl: "/api/data/EditTicketType",
    deleteUrl: "/api/data/DeleteTicketType",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Ticket Type",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Ticket Type",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,
    allElectricityType: [],

    xlsxHeaders: [],
    tableData: [],
  };

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
      allClaims: [],
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        const rows = apiResponse.data.respData.data;
        this.setState({ tableData: rows });
        this.buildExportHeaders(rows);
      }
    );
  }

  buildExportHeaders(rows) {
    if (!rows || rows.length === 0) return;
    let xlsxHeaders = [];
    for (var property in rows[0]) {
      if (rows[0].hasOwnProperty(property)) {
        xlsxHeaders.push({ title: property, dataIndex: property });
      }
    }
    this.setState({ xlsxHeaders });
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["ArName"] = apiResponse.data.respData.data.TYPE_NAME_AR;
      data["EnName"] = apiResponse.data.respData.data.TYPE_NAME_EN;
      data["KuName"] = apiResponse.data.respData.data.TYPE_NAME_KU;
      data["NeedEmployee"] = apiResponse.data.respData.data.NEED_EMPLOYEE;
      data["ChargeDescription"] = apiResponse.data.respData.data.CHARGE_DESCRIPTION;
      data["slaMinutes"] = apiResponse.data.respData.data.SLA_MINUTES;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data.ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.englishTicketType"),
        field: "TYPE_NAME_EN",
      },
      {
        id: 2,
        label: t("col.arabicTicketType"),
        field: "TYPE_NAME_AR",
      },
      {
        id: 3,
        label: t("col.kurdishTicketType"),
        field: "TYPE_NAME_KU",
      },
      {
        id: 4,
        label: t("col.needEmployee"),
        field: "NEED_EMPLOYEE",
        cellRenderer: ({ data }) => {
          return data.NEED_EMPLOYEE ? "Yes" : "No";
        },
      },
      {
        id: 5,
        label: t("col.chargeDescription"),
        field: "CHARGE_DESCRIPTION",
      },
      {
        id: 6,
        label: t("col.active"),
        field: "IS_ACTIVE",
        cellRenderer: ({ data }) => {
          return data.IS_ACTIVE ? "Yes" : "No";
        },
      },
      {
        id: 7,
        label: t("col.slaMinutes"),
        field: "SLA_MINUTES",
      },
      {
        id: 8,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 9,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 10,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB7A"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB7B"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.ticketTypes")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB79"]) && (
              <Button
                label={t("pages.addTicketType")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
            {this.state.tableData.length > 0 && (
              <ExportSheet
                header={this.state.xlsxHeaders}
                dataSource={this.state.tableData}
                fileName="TicketTypesExport"
                isRequiredNameDate={false}
                xlsx={XLSX}
              >
                <Button
                  className="p-button-rounded p-button-success"
                  label={t("btn.exportExcel")}
                  icon="fa fa-file-excel-o"
                />
              </ExportSheet>
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "EnName",
                label: t("col.englishTicketType"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArName",
                label: t("col.arabicTicketType"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuName",
                label: t("col.kurdishTicketType"),
                disabled: false,
              },
              {
                type: "text",
                id: "ChargeDescription",
                label: t("col.chargeDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "slaMinutes",
                label: t("col.slaMinutes"),
                disabled: false,
              },
              {
                type: "checkbox",
                id: "NeedEmployee",
                label: t("col.needEmployee"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(TicketType);
